const auth = {
  'sk': 'Queue System',
  'login-via-sso': 'Login via SSO',
  'login-locally': 'Login locally',
  login: 'Login',
  username: 'Username',
  password: 'Password',
  'username-required': 'Username is required',
  'password-required': 'Password is required',
  'login-as-worker': 'Login as employee',
  logout: 'Logout',
  'sso-info-1': 'SSO - login system for students',
  'sso-info-2': 'and for Politechnika Wrocławska\'s employees',
  error: 'Wrong login or password!',
  'back-to-home': 'Back to home page'
};

export default auth;
